const suppliers = {
  toast: {
    error: {
      badResponse: '[Proveedor] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Proveedor] se ha creado correctamente',
      },
      edit: {},
    },
  },
  createNew: 'Crear',
  import: 'Importar',
  importTitle: 'Suppliers Upload',
  updateRanking: 'Actualizar Clasificación',
  table: {
    headers: {
      name: 'Nombre',
      supplierStatus: 'Estado',
      rank: 'Rango',
      tier: 'Nivel',
      overallScore: 'Puntuación General',
      onTimePerformance: 'Rendimiento Puntual',
      noShowRate: 'Tasa de Ausencias',
      cancellationsRate: 'Tasa de Cancelaciones',
      acceptanceRate: 'Tasa de Aceptación',
      avgResponseTime: 'Tiempo Medio de Respuesta',
      vehicles: 'Vehículos',
      complaints: 'Quejas',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },

  create: {
    successToast: {
      message: '¡Éxito! ¡Proveedor creado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el proveedor',
    },
  },

  edit: {
    successToast: {
      message: '¡Éxito! ¡Proveedor actualizado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el proveedor',
    },
  },

  deleteModal: {
    header: 'Eliminar proveedores',
    body: 'Está a punto de eliminar {{num}} proveedores.',
  },

  deleteToast: 'No se pueden eliminar los proveedores',

  forms: {
    header: {
      createSupplier: {
        title: 'Crear',
      },

      updateSupplier: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      rank: {
        header: 'Rango del proveedor',
        fields: {
          rank: 'Rango {{rank}}',
          score: 'Nota: ',
        },
      },
      generalInformation: {
        header: 'Información general',
        fields: {
          name: 'Nombre',
          status: 'Estado',
          tier: 'Nivel',
          tierAndScore: 'Nivel y Puntaje del Proveedor',
          statusOptions: {
            select: 'Seleccionar',
            active: 'Activo',
            inactive: 'Inactiva',
          },
        },
      },
      supplierKpis: {
        header: 'KPIs del proveedor',
        fields: {
          onTimePerformance: 'Rendimiento a tiempo (%)',
          noShowRate: 'Tasa de no presentación (%)',
          cancellationsRate: 'Tasa de cancelaciones (%)',
          acceptanceRate: 'Tasa de aceptación (%)',
          avgResponseTime: 'Tiempo de respuesta promedio (min)',
          complaints: 'Quejas',
        },
      },
      advancedSettings: {
        header: 'Configuración avanzada',
        fields: {
          areas: 'Zonas',
          attributes: 'Atributos',
          minTrips: 'Viajes mínimos',
          maxTrips: 'Viajes máximos',
          allowDecline: 'Permitir rechazar',
          allowSharedRides: 'Permitir Corridas Compartilhadas',
          weekDays: 'Disponibilidad entre semana',
        },
      },
      contactInformation: {
        header: 'Información de contacto',
        fields: {
          name: 'Nombre',
          type: 'Tipo',
          phone: 'Telefono',
          email: 'Correo electrónico',
          address: 'Dirección',
          comment: 'Comentario',
          btnAddContact: 'Agregar contacto',
        },
      },
      notes: {
        header: 'Notas',
        fields: {
          notes: 'Notas',
        },
      },
      vehiclesTable: {
        cells: {
          name: 'Nombre',
          seats: 'Asientos',
          attributes: 'Atributos',
        },
      },
    },
    select: 'Seleccionar',
  },
  delete: {
    confirmation: {
      header: 'Eliminar la confirmación de proveedor',
      body: 'Los proveedores se eliminaron correctamente',
    },
  },
};

export default suppliers;
